import React from 'react'

import { Box, useMediaQuery, useTheme } from '@mui/material'
import { pick } from 'lodash'
import { PropTypes } from 'prop-types'

import Filter from './Filter'
import QuickFilter from './QuickFilter'

const MAX_NOF_LG = 5
const MAX_NOF_MD = 3

const FilterArea = ({
  defaultValues,
  sx,
  children,
  maxNumberOfFields,
  ...props
}) => {
  const theme = useTheme()
  const lgUp = useMediaQuery(theme.breakpoints.up('lg'))
  const mdDown = useMediaQuery(theme.breakpoints.down('md'))

  const maxNoF =
    typeof maxNumberOfFields === 'number'
      ? maxNumberOfFields
      : lgUp
      ? maxNumberOfFields?.lg ?? MAX_NOF_LG
      : maxNumberOfFields?.md ?? MAX_NOF_MD
  const allFields = Object.keys(defaultValues) || []
  const quickFields = children || mdDown ? [] : allFields.slice(0, maxNoF)

  return (
    <Box
      sx={(theme) => ({
        display: 'flex',
        gap: 2,
        pb: 1,
        mb: 1,
        borderBottom: `1px solid ${theme.palette.divider}`,
        ...sx,

        '&:empty': {
          display: 'none',
        },
      })}
    >
      {children}
      {quickFields.length > 0 && (
        <QuickFilter
          {...props}
          defaultValues={pick(defaultValues, quickFields)}
        />
      )}
      {allFields.length > quickFields.length && (
        <Filter {...props} defaultValues={defaultValues} />
      )}
    </Box>
  )
}

FilterArea.defaultProps = {
  sx: {},
  values: {},
  onApply: () => {},
  defaultValues: {},
}

FilterArea.propTypes = {
  sx: PropTypes.shape(),
  values: PropTypes.shape(),
  defaultValues: PropTypes.shape(),
  onApply: PropTypes.func,
  form: PropTypes.node,
  validationSchema: PropTypes.shape(),
  searchPlaceholder: PropTypes.string,
  maxNumberOfFields: PropTypes.oneOfType([PropTypes.number, PropTypes.shape()]),
}

export default FilterArea
